<script setup lang="ts">

import {useCommunityDataPublic} from '@/stores/communityDataPublic'
import {computed, onMounted} from "vue";
import { useI18n } from 'vue-i18n';
import { SecondaryButton , PrimaryButton } from '@es-bill/es-bill-common-components';
import {useRouter} from "vue-router";

const { t } = useI18n();
const communityDataPublicStore = useCommunityDataPublic()
const communityPublicLast = computed(()=> communityDataPublicStore.getLastCommunity);

const router = useRouter()

onMounted(() => {

  // we want on nav back land on the first form page
  //router.removeRoute('JoinAsMember')  > does not work...
})

</script>

<template>
  <v-container class="containerStandard mainContainer">

    <v-img v-if="communityPublicLast?.logoSrc"
      width="200"
      :src="communityPublicLast?.logoSrc"
      alt="logo-eeg"
    ></v-img>


    <v-container class="containerText">
      <p class="textHeadline">{{ t('thankYouForApplication') }}</p>

      <p class="textDescriptor textContainer">
        {{ t('applicationConfirmation') }}
      </p>
      <p class="textDescriptor textContainer">
        {{ t('applicationConfirmation1') }}
      </p>
    </v-container>

    <div class="buttons">
      <PrimaryButton :href="communityPublicLast?.uriMoreInfo" target="_blank" v-if="communityPublicLast && communityPublicLast.uriMoreInfo?.length" :text="t('communityButton')"/>
      <SecondaryButton href="https://www.so-strom.at/" target="_blank" :text="'so-strom'"/>
    </div>


  </v-container>
</template>

<style scoped lang="scss">

.mainContainer {
  display: flex;
  padding: 5px 0px 60px 0px;
  flex-direction: column;
  align-items: center;
  gap: 48px;
  max-width: 100%;
}

.containerText {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  align-self: stretch;
  padding: 0 16px;
}

.buttons {
  display: flex;
  flex-direction: row;
  gap: 24px;
  flex-wrap: wrap;
  justify-content: center;
  width: 100%;
  padding: 0 16px;

  @media (max-width: 600px) {
    flex-direction: column;
    gap: 16px;
    align-items: center;
  }
}

.textContainer {
  max-width: 467px;
  text-align: center;

  @media (max-width: 600px) {
    max-width: 100%;
    padding: 0 8px;
  }
}

.btnWebsite {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  min-width: 120px;

  @media (max-width: 600px) {
    margin-top: 20px;
    width: 100%;
    max-width: 280px;
  }
}

// Additional responsive adjustments
@media (max-width: 768px) {
  .mainContainer {
    gap: 32px;
    padding: 12px;
  }

  .containerText {
    gap: 12px;
  }
}

@media (max-width: 480px) {
  .mainContainer {
    gap: 24px;
    padding: 8px;
  }

  .buttons {
    gap: 12px;
  }
}

</style>
